module.exports = __webpack_public_path__ + "static/media/Asset 48.929fd594.jpg";